import { GenericCollectionFactory } from "../../Common/_generics/GenericCollectionFactory";

export const PMSLocationRoomsCollection = GenericCollectionFactory("PMS_LOCATION_ROOMS", "uid")